export default [
  { name: 'Streams', also: 1384,  price: 573.40, plus: 95.20 },
  { name: 'Downloads', also: 201,  price: 306.80, plus: 63.40 },
  { name: 'Physische Verkäufe', also: 29,  price: 293.20, plus: 29.70 },
  { name: 'Weitere Einnahmen', also: 'Mitwirkender',  price: 107.90, plus: 12.30 },
]
